import React from "react";
import Call from "../assets/icons/Call";
import { Link } from "react-router-dom";
import Email from "../assets/icons/Email";
import Location from "../assets/icons/Location";
import { useTranslation } from "react-i18next";

const Contact = () => {

 const { t } = useTranslation();

  return (
    <React.Fragment>
      <section className="contact_banner">
        <div className="wrapper">
          <div className="cnt_content">
            <h1 className="usable_title">
              {t("contact")} <span>{t("us")}</span>
            </h1>
            <p className="para_common">
            {t("any_question_or_remarks_just_write_us_a_message")}
            </p>
          </div>
        </div>
      </section>
      <section className="cnt_contact">
        <div className="wrapper">
          <div className="contact_grid">
            <div className="cnt_gr_first">
              <p className="cnt_gr_title">{t("contact_information")}</p>
              <p className="para_common">{t("say_something_to_start_a_live_chat")}</p>
              <div className="cnt_details">
                <div className="ctn_dt_flex">
                  <Call /> <Link to={"tel:+371 22 025 354"}>+371 22 025 354</Link>
                </div>
                <div className="ctn_dt_flex">
                  <Email />{" "}
                  <Link to={"mailto:info@loadinn.lv"}>
                    info@loadinn.lv
                  </Link>
                </div>
                <div className="ctn_dt_flex location">
                  <Location />{" "}
                  <Link
                    to=""
                    target="_blank"
                  >
                    Estonia, Harju maakond, Tallinn, Kesklinna linnaosa, Ahtri tn 12, 15551
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Contact;
